import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * Generate AI content for a Company Direction section.
 * @param {Object} params
 * @param {'mission'|'vision'|'values'} params.section
 * @param {string} [params.businessName]
 * @param {string} [params.industry]
 * @param {string} [params.currentValue]
 * @param {string} [params.instructions]
 * @returns {Promise<{section:string, content?:string, values?:Array<{title:string,description:string}>}>}
 */
export const generateCompanyDirection = async (params) => {
  const fn = httpsCallable(functions, 'generateCompanyDirection');
  const result = await fn(params);
  return result.data;
};

/**
 * AI-tailor an HR template to a specific company.
 * @param {Object} params
 * @param {string} params.templateTitle
 * @param {string} [params.templateDescription]
 * @param {string} [params.businessName]
 * @param {string} [params.location]
 * @param {string} [params.instructions]
 * @returns {Promise<{templateTitle:string, content:string}>}
 */
export const tailorHrTemplate = async (params) => {
  const fn = httpsCallable(functions, 'tailorHrTemplate');
  const result = await fn(params);
  return result.data;
};

/**
 * Transform a pasted class/meeting summary into an informative lesson description.
 * @param {Object} params
 * @param {string} params.summary - The pasted class call summary.
 * @param {string} [params.lessonTitle]
 * @param {string} [params.courseTitle]
 * @returns {Promise<{content:string}>}
 */
export const generateLessonDescription = async (params) => {
  const fn = httpsCallable(functions, 'generateLessonDescription');
  const result = await fn(params);
  return result.data;
};
